import { ANNULUS_CONDITION } from 'src/app/core/models/results/annulus-condition';
import { DETAILED_RESULTS_FAD_FLEX } from 'src/app/core/models/results/detailed-results-fad-flex';
import { ConnectorFatigueStructure } from './connector-fatigue-structure.model';

export class ConnectorFatigueInstructions {
  id?: number;
  histogram: boolean;
  detailedResults: DETAILED_RESULTS_FAD_FLEX;
  snCurveId: number;
  anularCondition: ANNULUS_CONDITION;
  stressConcentrationFactorMean: number;
  stressConcentrationFactorAlternate: number;
  structures: ConnectorFatigueStructure[];

  constructor(
    props = {
      id: null,
      histogram: false,
      snCurveId: -1,
      detailedResults: DETAILED_RESULTS_FAD_FLEX.NONE,
      anularCondition: ANNULUS_CONDITION.DRY,
      stressConcentrationFactorMean: 1,
      stressConcentrationFactorAlternate: 1,
      structures: [],
    },
  ) {
    Object.assign(this, props);
  }
}
